export const GET_RUBRO = "GET_RUBRO";
export const GET_RUBRO_FAIL = "GET_RUBRO_FAIL";
export const GET_RUBRO_SUCCESS = "GET_RUBRO_SUCCESS";
